module.exports = __webpack_public_path__ + "static/media/Tempo.91b3936c.md";